import * as req from 'api/actions';
import * as c from './constants';

export const findPayment = (payload, callback) =>
  req.findPost(
    c.FIND_PAYMENT,
    'api/v1/administrators/payments/inquiry',
    payload,
    callback
  );

export const tagAsForPosting = (payload, callback) =>
  req.findPost(
    c.TAG_FOR_POSTING,
    'api/v1/administrators/payments/rollback',
    payload,
    callback
  );

export const viewPaymentLogs = (payload, callback) =>
  req.findPost(
    c.VIEW_PAYMENT_LOGS,
    'api/v1/administrators/payments/inquiry/logs',
    payload,
    callback
  );

export const viewPaymentLogsForTxn = (payload, callback) =>
  req.findPost(
    c.VIEW_PAYMENT_LOGS_FOR_TXNID,
    'api/v1/administrators/payments/inquiry/logs',
    payload,
    callback
  );

export const changeTxn = (payload, callback) =>
  req.findPost(
    c.UPDATE_TXN,
    'api/v1/administrators/payments/transaction_histories',
    payload,
    callback
  );

export const postPaymentToQpax = (payload, callback) =>
  req.findPost(
    c.POST_PAYMENT_TO_QPAX,
    'api/v1/administrators/payments/post_to_qpax',
    payload,
    callback
  );

export const manualExpireRefno = (payload, callback) =>
  req.findPost(
    c.MANUAL_EXPIRE_REFNO,
    'api/v1/administrators/payments/expire',
    payload,
    callback
  );

export const approveRefund = (payload, callback) =>
  req.findPost(
    c.APPROVE_REFUND,
    'api/v1/administrators/payments/refund_gcash_payment',
    payload,
    callback
  );

export const viewPaymentLogsForAmount = (payload, callback) =>
  req.findPost(
    c.VIEW_PAYMENT_LOGS_FOR_AMOUNT,
    'api/v1/administrators/payments/inquiry/logs',
    payload,
    callback
  );

export const changeAmount = (payload, callback) =>
  req.findPost(
    c.UPDATE_AMOUNT,
    'api/v1/administrators/payments/update_amount',
    payload,
    callback
  );

export const reassess = (payload, callback) =>
  req.findPost(
    c.REASSESS,
    `api/v1/administrators/payments/rollback_assessment`,
    payload,
    callback
  );